import {
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SunEditor from "suneditor-react";

import { Button, Card, Col, Divider, Radio, Row, Space, Upload } from "antd";
import { DatePicker, Input, Select, Switch } from "components/form";

import uploadStyles from "components/elements/upload/Upload.module.css";
import { useTranslation } from "react-i18next";
import "suneditor/dist/css/suneditor.min.css";
import schema, {
  ANNOUNCEMENT_TYPE,
  initialValues as INITIAL_VALIES,
} from "../schemas/newsSchema";
import { setCurrentNews } from "../slices/newsSlice";
import styles from "../styles/NewCreate.module.css";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  console.log("img", img);
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  return false;
};

function formatDate(dateString, pattern = "DD-MM-YYYY") {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format("DD-MM-YYYY");
}

const NewsForm = ({
  initialValues = {},
  organizationUnderOptions = [],
  employeeTypeOptions = [],
  rolePermissionOptions = [],
  onSubmit = () => { },
  onBack = () => { },
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [coverImageUrl, setCoverImageUrl] = useState();
  const [attachments, setAttachments] = useState([]);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("common.upload")}
      </div>
    </button>
  );


  // console.log("initialValues", initialValues);
  useEffect(() => {
    if (initialValues.cover) {
      setLoading(true);
      const decodedString = atob(initialValues.cover);
      let bytes = new Uint8Array(decodedString.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = decodedString.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: 'image/png' });
      getBase64(blob, (url) => {
        setCoverImageUrl(url);
      });
      setLoading(false);
    }
  }, [initialValues.cover]);

  useEffect(() => {
    setAttachments(initialValues.attachment || []);
  }, [initialValues.attachment]);

  useEffect(() => {
    return () => {
      dispatch(setCurrentNews({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALIES,
        ...initialValues,
        newsCode: initialValues?.announcementNewsCode
      }}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, errors, setFieldValue = () => { }, setTouched = () => { } }) => {
        const onCoverUpload = (info) => {
          try {
            setLoading(true);
            setFieldValue("cover", info.file);
            console.log("info.file", info.file);
            getBase64(info.file, (url) => {
              setLoading(false);
              setCoverImageUrl(url);
            });
          } catch (error) {
          } finally {
            setLoading(false);
          }
        };
        console.log("values", errors);

        return (
          <Form className={styles.container}>
            <Space size={24} direction="vertical">
              <Card style={{ border: "1px solid #EAECF0" }}>
                <Row justify="space-between">
                  <b className={styles.infoTopic}>
                    {t("news.label.news_detail")}
                  </b>
                </Row>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <Row style={{ marginBottom: "8px" }}>
                      <p>{t("news.label.cover")}</p>
                    </Row>
                    <Upload
                      name="cover"
                      className={uploadStyles.container}
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={onCoverUpload}
                      action={null}
                    >
                      {coverImageUrl ? (
                        <img alt="cover" src={coverImageUrl} width="100%" />
                      ) : (
                        uploadButton
                      )}
                    </Upload>
                  </Col>
                  <Col span={12}>
                    <Row gutter={[0, 16]}>
                      <Col span={24}>
                        <Input
                          name="newsCode"
                          required
                          label={
                            t("news.label.code")
                          }
                          placeholder={
                            t("news.label.code")
                          }
                          size="large"
                        />
                      </Col>
                      <Col span={24}>
                        <Input
                          name="subject"
                          required
                          label={
                            t("news.label.subject")
                          }
                          placeholder={
                            t("news.label.subject")
                          }
                          size="large"
                        />
                      </Col>
                      <Col span={12}>
                        <p className={styles.text}>
                          {t("news.label.pin_this_announce")}
                        </p>
                        <Switch name="pinAnnounce" />
                      </Col>
                      <Col span={12}>
                        <p className={styles.text}>{t("news.label.acknowledge")}</p>
                        <Switch name="acknowledge" />
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <p>{t("news.label.description")}</p>
                    {values.announcementNewsId && values.description ? (
                      <SunEditor
                        name="description"
                        defaultValue={values.description}
                        width="100%"
                        setContents={values.description}
                        onChange={(content) =>
                          setFieldValue("description", content)
                        }
                        setOptions={{
                          height: 300,
                          buttonList: [
                            ["undo", "redo"],
                            ["bold", "underline", "italic"],
                            ["fontColor", "hiliteColor"],
                            ["align", "list"],
                            ["link", "image"],
                            ["removeFormat"],
                            ["preview"]

                          ],
                          placeholder: "Write something..."
                        }}
                      />
                    ) : (
                      <SunEditor
                        name="description"
                        width="100%"
                        onChange={(content) =>
                          setFieldValue("description", content)
                        }
                        setOptions={{
                          height: 300,
                          buttonList: [
                            ["undo", "redo"],
                            ["bold", "underline", "italic"],
                            ["fontColor", "hiliteColor"],
                            ["align", "list"],
                            ["link", "image"],
                            ["removeFormat"],
                            ["preview"]
                          ],
                          placeholder: "Write something..."
                        }}
                      />
                    )}
                  </Col>
                  <Col span={24}>
                    <p>{t("news.label.attachment")}</p>
                  </Col>
                  <Col span={24}>
                    <Upload
                      name="attachment"
                      action={null}
                      beforeUpload={(file) => {
                        const modifiedAttachment = {
                          content: file,
                          fileName: file.name,
                          ext: file.type,
                        };
                        const newAttachments = [
                          ...attachments,
                          modifiedAttachment,
                        ];
                        setAttachments(newAttachments);
                        setFieldValue("attachment", newAttachments);
                        return false;
                      }}
                      onRemove={(file) => {
                        const bufferAttachments = [...attachments];
                        const index = bufferAttachments.indexOf(file);
                        const newFileList = bufferAttachments.slice();
                        newFileList.splice(index, 1);
                        setAttachments(newFileList);
                        setFieldValue("attachment", newFileList);
                      }}
                      fileList={attachments.map((a) => a.content)}
                    >
                      <Button htmlType="button" type="default">
                        {loading ? <LoadingOutlined /> : <UploadOutlined />}
                        {t("common.upload")}
                      </Button>
                    </Upload>
                  </Col>
                  <Col span={12}>
                    <Radio.Group
                      onChange={(e) => {
                        setFieldValue("announcementType", e.target.value);
                        setTouched({}, false);
                      }}
                      value={values.announcementType}
                    >
                      <Radio value={ANNOUNCEMENT_TYPE.BROADCAST_NOW}>
                        {t("news.label.publish_now")}
                      </Radio>
                      <Radio value={ANNOUNCEMENT_TYPE.SCHEDULE}>
                        {t("news.label.schedule")}
                      </Radio>
                    </Radio.Group>
                  </Col>
                  {values.announcementType === ANNOUNCEMENT_TYPE.SCHEDULE ? (
                    <>
                      <Col span={6}>
                        <DatePicker
                          name="startAnnounce"
                          label={
                            t("news.label.start_announce") +
                            t("common.required_field_suffix")
                          }
                          placeholder={t('common.placeholder.ddmmyyyy')}
                          size="large"
                          format={formatDate()}
                        />
                      </Col>
                      <Col span={6}>
                        <DatePicker
                          name="endAnnounce"
                          label={t("news.label.end_announce")}
                          placeholder={t('common.placeholder.ddmmyyyy')}
                          size="large"
                          format={formatDate()}
                        />
                      </Col>
                    </>
                  ) : (
                    <></>
                  )}
                  <Col span={24}>
                    <div>
                      <b className={styles.infoTopic}>
                        {t("news.label.announcement_to")}
                      </b>
                      <Divider />
                      <Row gutter={[24, 16]}>
                        <Col span={12}>
                          <Select
                            name="departmentId"
                            required
                            label={
                              t("news.label.department")
                            }
                            placeholder={t('please-select-1')}
                            size="large"
                            mode="multiple"
                            options={organizationUnderOptions}
                          />
                        </Col>
                        <Col span={12}>
                          <Select
                            name="employeeTypeId"
                            required
                            label={t("news.label.employee_type")}
                            placeholder={t('please-select-1')}
                            size="large"
                            mode="multiple"
                            options={employeeTypeOptions}
                          />
                        </Col>
                        <Col span={12}>
                          <Select
                            name="audienceGroup"
                            required
                            label={
                              t("news.label.audience_group")
                            }
                            placeholder={t('please-select-1')}
                            size="large"
                            mode="multiple"
                            options={rolePermissionOptions}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row justify="end" style={{ paddingTop: "24px" }}>
                  <Space size={12}>
                    <Button
                      id="news__cancelBtn"
                      type="default"
                      onClick={onBack}
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button type="primary" htmlType="submit" style={{ backgroundColor: "var(--button-color)", height: "40px", borderRadius: "8px" }}>
                      {t("common.announce").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Card>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
};

export default NewsForm;
